import { afterEvent, atRoundEnd, defineGameCard, roundMarkerStatus } from '../authoring/index.js';
export const HeatSinkCard = defineGameCard({
    id: 'heat_sink',
    gameplay: {
        type: 'UNIT', cost: 3,
        baseStats: { attack: 2, health: 6 },
    },
    presentation: {
        name: 'Теплопоглотитель',
        description: 'Раз за раунд переносит 1 Перегрев с другой нагревшейся союзной карты на себя. В конце раунда при Перегреве 3 или больше получает 2 урона и охлаждается на 3.',
        glyph: {
            colors: ['#D59981', '#10213A', '#8B979F', '#697481', '#596473'],
            rows: [
                '.....1..1..1........',
                '.....1..1...1.......',
                '......1..1..1.......',
                '......1..1..1.......',
                '.......1..1..1......',
                '....................',
                '....................',
                '.....2222222222.....',
                '....213333333342....',
                '....2355555534252...',
                '....2324245544252...',
                '....2325255544252...',
                '....2325255544242...',
                '....2325255544252...',
                '....2325255544252...',
                '....2325255544252...',
                '...24355555444252...',
                '...2252222222222....',
                '....222233332222....',
                '...2....2222....2...',
            ],
        },
    },
    role: 'playable',
    abilities: [
        afterEvent({
            event: 'HeatChanged',
            abilityId: 'heat_transfer',
            when: (ctx, event) => {
                if (ctx.self === undefined || event.reason !== 'heated'
                    || event.instanceId === ctx.self.id
                    || ctx.self.vars.heatTransferRound === ctx.round)
                    return false;
                const target = ctx.q.allUnits().find((unit) => unit.id === event.instanceId);
                return target?.controllerId === ctx.self.controllerId && target.heat > 0;
            },
            run: (ctx, event) => {
                if (ctx.self === undefined)
                    return;
                const target = ctx.q.allUnits().find((unit) => unit.id === event.instanceId);
                if (target === undefined)
                    return;
                if (!ctx.ops.cool(target.id, 1))
                    return;
                ctx.ops.addHeat(ctx.self.id, 1);
                ctx.ops.setVar('heatTransferRound', ctx.round);
            },
        }),
        atRoundEnd((ctx) => {
            const self = ctx.self;
            if (self === undefined || self.heat < 3)
                return;
            ctx.ops.dealDamage({ kind: 'unit', instanceId: self.id }, 2);
            if (ctx.q.allUnits().some((unit) => unit.id === self.id))
                ctx.ops.cool(self.id, 3);
        }),
    ],
    ui: {
        mechanics: ['heat'],
        publicVars: { heatTransferRound: { key: 'heatTransferRound', kind: 'number' } },
        statusProviders: [roundMarkerStatus({
                fact: 'heatTransferRound',
                id: 'heat-sink-used',
                symbol: '✓',
                label: 'Перенос Перегрева',
                tone: 'neutral',
            })],
    },
});
//# sourceMappingURL=heat-sink.js.map